module.exports = __webpack_public_path__ + "img/logo_a.0ff26132.jpg";